module.exports = "/images/gotham-2.jpg";